import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import "../checkout/Checkout.scss";

const ConfirmationCheckout: React.FC<RouteComponentProps> = (props) => {
  const { history } = props;
  const { t } = useTranslation("radar");
  return (
    <div className="confirmacao-checkout">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1>{t("pages.Checkout.ConfirmacaoTitulo")}</h1>
        <p>{t("pages.Checkout.ConfirmacaoText")}</p>
        <button
          className="botao-roxo"
          onClick={() => history.push("/diagnostic")}
        >
          {t("pages.Checkout.ConfirmacaoButton")}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationCheckout;
